import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const files = require.context('./modules', true, /\.js$/);
let mainRoutes = [];
files.keys().forEach((key) => {
  mainRoutes = mainRoutes.concat(files(key).default);
});

let router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/binding-doctors'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../pages/home/index.vue')
    },
    {
      path: '/binding-doctors',
      name: 'BindingDoctors',
      component: () => import('../pages/doctors/BindingDoctors'),
      meta: {
        title: '我的医生'
      }
    },
    {
      path: '/binding',
      name: 'BindingInfo',
      component: () => import('../pages/binding'),
      meta: {
        title: '个人信息',
        getUserInfo: true
      }
    },
    {
      path: '/binding-mobile',
      name: 'BindingMobilePage',
      component: () => import('../pages/binding/bindingMobile.vue'),
      meta: {
        title: '绑定手机号'
      }
    },
    {
      path: '/user-center',
      name: 'UserCenter',
      component: () => import('../pages/userCenter'),
      meta: {
        title: '个人中心',
        getUserInfo: true
      }
    },
    {
      path: '/user-info',
      name: 'UserInfo',
      component: () => import('../pages/userCenter/UserInfo'),
      meta: {
        title: '个人信息',
        getUserInfo: true
      }
    },
    {
      path: '/edit-name',
      name: 'EditName',
      component: () => import('../pages/userCenter/EditName'),
      meta: {
        title: '姓名'
      }
    },
    {
      path: '/edit-idcard',
      name: 'EditIdCard',
      component: () => import('../pages/userCenter/EditIdCard'),
      meta: {
        title: '身份证号'
      }
    },
    {
      path: '/doctor-detail/:id',
      name: 'DoctorDetail',
      component: () => import('../pages/doctors/DoctorDetail'),
      meta: {
        title: '医生详情'
      }
    },
    {
      path: '/link-mobile',
      name: 'LinkMobile',
      component: () => import('../pages/linkOldUser/LinkMobile.vue')
    },
    {
      path: '/link-success',
      name: 'LinkSuccess',
      component: () => import('../pages/linkOldUser/LinkSuccess'),
      meta: {
        title: '关联结果'
      }
    },
    {
      path: '/link-fail',
      name: 'LinkFail',
      component: () => import('../pages/linkOldUser/LinkFail'),
      meta: {
        title: '关联结果'
      }
    },
    {
      path: '/recipe-view',
      name: 'RecipeView',
      component: () => import('../pages/recipe/RecipeView.vue'),
      meta: {
        title: '用药建议详情',
        getUserInfo: true
      }
    },
    {
      path: '/recipe-list',
      name: 'RecipeList',
      component: () => import('../pages/recipe/RecipeList.vue'),
      meta: {
        title: '我的用药建议',
        getUserInfo: true
      }
    },
    {
      path: '/payment/success',
      name: 'PaymentSuccess',
      component: () => import('../pages/payment/paymentSuccess2.vue'),
      meta: {
        title: '支付结果'
      }
    },
    {
      path: '/payment/fail',
      name: 'PaymentFail',
      component: () => import('../pages/payment/paymentFail.vue'),
      meta: {
        title: '支付失败'
      }
    },

    {
      path: '/customer-service',
      name: 'CustomerService',
      component: () => import('../pages/customerService/index.vue'),
      meta: {
        title: '客服'
      }
    },
    {
      path: '/upd-mobile',
      name: 'UpdMobile',
      component: () => import('../pages/userCenter/changeMobile.vue'),
      meta: {
        title: '手机号码',
        getUserInfo: true
      }
    },
    {
      path: '/message',
      name: 'message',
      component: () => import('../pages/message/index'),
      meta: {
        title: '医生回复消息',
        getUserInfo: true
      }
    },
    {
      path: '/message/advice',
      name: 'advice',
      component: () => import('../pages/message/advice'),
      meta: {
        title: '医嘱消息',
        getUserInfo: true
      }
    },
    {
      path: '/message/template',
      name: 'template',
      component: () => import('../pages/message/template'),
      meta: {
        title: '消息',
        getUserInfo: true
      }
    },
    {
      path: '/drug-venue',
      name: 'drugVenue',
      component: () => import('../pages/drugVenue/index'),
      meta: {
        title: '药品会场'
      }
    },
    {
      path: '/all-categories',
      name: 'allCategories',
      component: () => import('../pages/allCategories/index'),
      meta: {
        title: '全部分类'
      }
    },
    {
      path: '/request-cart',
      name: 'requestCart',
      component: () => import('../pages/drugVenue/requestCart'),
      meta: {
        title: '需求清单',
        getUserInfo: true,
        telescope: 'zyyd-page-Cart'
      }
    },
    {
      // 药品详情
      path: '/specification',
      component: () => import('../pages/specification'),
      meta: {
        title: '商品详情',
        getUserInfo: true
      }
    },
    {
      path: '/doctor-share',
      name: 'doctorShare',
      component: () => import('../pages/doctors/sharepage.vue'),
      meta: {
        title: '医生详情'
      }
    },
    {
      path: '/information-upload',
      name: 'informationUpload',
      component: () => import('../pages/informationUpload'),
      meta: {
        title: '上传资料'
      }
    },
    {
      path: '/case-list',
      name: 'CaseList',
      component: () => import('../pages/case/caseList.vue'),
      meta: {
        title: '病历管理',
        getUserInfo: true
      }
    },
    {
      path: '/record-list',
      name: 'RecordList',
      component: () => import('../pages/case/recordList.vue'),
      meta: {
        title: '病历列表',
        getUserInfo: true
      }
    },
    {
      path: '/record-view',
      name: 'RecordView',
      component: () => import('../pages/case/recordView.vue'),
      meta: {
        title: '病历详情',
        getUserInfo: true
      }
    },
    {
      path: '/modify-nickname',
      name: 'ModifyNickname',
      component: () => import('../pages/userCenter/modifyNickname.vue'),
      meta: {
        title: '修改昵称',
        getUserInfo: true
      }
    },
    {
      path: '/order-list/:active',
      name: 'orderList',
      component: () => import('../pages/orderList/index.vue'),
      meta: {
        title: '我的订单',
        telescope: 'zyyd-page-OrderList'
      }
    },
    {
      path: '/order-detail/:id',
      name: 'orderDetail',
      component: () => import('../pages/orderDetail/index.vue'),
      meta: {
        title: '订单详情',
        telescope: 'zyjk-page-mzyjk-mall-OrderDetails'
      }
    },
    {
      path: '/invoice-detail/:id',
      name: 'invoiceDetail',
      component: () => import('../pages/invoiceDetail/index.vue'),
      meta: {
        title: '发票详情'
        // telescope: 'zyjk-page-mzyjk-mall-OrderDetails'
      }
    },
    // 医生发过来商品推荐 中间过渡页面
    {
      path: '/im-recommend-loading',
      name: 'imRecommendLoading',
      component: () => import('../pages/recommend/recommendLoading.vue'),
      meta: {
        title: '加载中…'
      }
    },
    // 需求单 支付中间页
    {
      path: '/im-require-loading',
      name: 'requireLoading',
      component: () => import('../pages/recommend/requireLoading.vue'),
      meta: {
        title: '加载中…'
      }
    },
    {
      path: '/settlement',
      name: 'Settlement',
      component: () => import('../pages/recommend/settlement.vue'),
      meta: {
        title: '购物申请'
      }
    },
    {
      path: '/recommend',
      name: 'Recommend',
      component: () => import('../pages/recommend'),
      meta: {
        title: '商品推荐'
      }
    },
    {
      path: '/preOrder',
      name: 'PreOrder',
      component: () => import('../pages/preOrder'),
      meta: {
        title: '提交订单'
      }
    },
    {
      path: '/placeOrder',
      name: 'PlaceOrder',
      component: () => import('../pages/placeOrder/index'),
      meta: {
        title: '填写订单'
      }
    },
    {
      path: '/fatherOrderList',
      name: 'fatherOrderList',
      component: () => import('../pages/fatherOrderDetail/index'),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/pay-advisory',
      name: 'payAdvisory',
      component: () => import('../pages/payAdvisory/index'),
      meta: {
        title: '图文问诊',
        authorization: true
      }
    },
    {
      path: `/logistics/:id`,
      name: 'logistics',
      component: () => import('../pages/logistics/index.vue'),
      meta: {
        title: '物流信息',
        authorization: true
      }
    },
    {
      path: '/logistics-list/:id',
      name: 'logisticsList',
      component: () => import('../pages/logistics/list.vue'),
      meta: {
        title: '物流信息',
        authorization: true
      }
    },
    {
      path: '/voice-play',
      name: 'voicePlay',
      component: () => import('../pages/voicePlay/index.vue'),
      meta: {
        title: '语音消息',
        authorization: true
      }
    },
    {
      path: '/voice-play-test',
      name: 'voicePlayTest',
      component: () => import('../pages/voicePlay/test.vue'),
      meta: {
        title: '语音消息',
        authorization: true
      }
    },
    {
      path: '/disease-desc',
      name: 'DiseaseDesc',
      component: () => import('../pages/diseaseDesc/index.vue'),
      meta: {
        title: '病情描述',
        authorization: true
      }
    },
    {
      path: `/follow-up/list`,
      name: 'followUpList',
      component: () => import(`@/pages/followUpPlan/list/index.vue`),
      meta: {
        title: '健康计划',
      },
    },
    {
      path: `/follow-up/detail/:id`,
      name: 'followUpDetail',
      component: () => import(`@/pages/followUpPlan/detail/index.vue`),
      meta: {
        title: '健康计划',
      },
    },
    {
      path: `/follow-up/history`,
      name: 'followUpHistory',
      component: () => import(`@/pages/followUpPlan/history/index.vue`),
      meta: {
        title: '历史健康计划',
      },
    },
    {
      path: "/questionnaire",
      name: "questionnaire",
      component: () => import('@/pages/questionnaire/index.vue')
    },
    {
      path: "/questionnaire/answer",
      name: "questionnaireAnswer",
      component: () => import('@/pages/questionnaire/answer.vue'),
    },
    ...mainRoutes
  ]
});

export default router;
